<script lang="ts">
	import { onMount } from 'svelte';
	import { activeLanguage, languages } from '$lib/stores/languages';
	import type { LayoutLoad } from './$types';
	import '../app.postcss';

	export let data: LayoutLoad;

	function setInitLanguage(locale: string): void {
		const found = $languages.find((lang) => lang.abbreviation === locale);
		if (found) {
			activeLanguage.set(found);
		}
	}

	onMount(() => {
		setInitLanguage(data.initLocale);
	});

	function touchHandler() {
		const urlParams = new URLSearchParams(window.location.search);
		const emitClicksParam = urlParams.get('emitclicks') === '1';
		if(emitClicksParam){
				window.parent.postMessage({
				type:'resetInactivityTimerDataType',
				content: ''
			}, '*')
		}
	}
</script>

<div class="app"
  on:click={touchHandler}
  on:touchstart={touchHandler}
  on:touchmove={touchHandler}
>
	<slot />
</div>
